import Core from '../plugin-core-system/core.class.js';
import Focus from '../helper/focus.helper.js';
import Tobii from '@midzer/tobii';

export default class CsLightbox extends Core {

  initLightbox() {
    const tobii = new Tobii({
      selector: '.js-lightbox',
      navLabel: ['Zurück', 'Weiter'],
      closeLabel: ['Galerie schließen']
    });

    // Custom Close Button Initialization
    const initCloseButtons = function() {
      const lightboxContainer = document.querySelector('.tobii');
      lightboxContainer.addEventListener('click', (e) => {
        if (e.target.matches('.js-close-tobii-gallery')) {
          e.preventDefault();
          tobii.close();
        }
      });
    };

    // set Control Visibility: set navigation buttons enabled or disabled
    const setControlVisibility = function(control, enable = true) {
      if (enable) {
        control.removeAttribute('disabled');
        control.setAttribute('aria-hidden', false);
      } else {
        control.setAttribute('disabled', 'disabled');
        control.setAttribute('aria-hidden', true);
      }
    };

    // check Control Visibility: check if navigation buttons should be enabled or disabled
    const checkControlVisibility = function(lightbox) {
      const index = tobii.slidesIndex();
      const isFirst = (index === 0);
      const isLast = (index === tobii.slidesCount() - 1);

      const prevButton = lightbox.querySelector('.tobii__btn--previous');
      const nextButton = lightbox.querySelector('.tobii__btn--next');

      //If it is the first element, it will pass false
      setControlVisibility(prevButton, !isFirst);
      //If it is the last element, it will pass false
      setControlVisibility(nextButton, !isLast);
    };

    tobii.on('open', (e) => {
      const closeButton = document.querySelector('.tobii__btn--close');
      // currentSlide: through searches the entire .tobii
      const currentSlide = e.target.querySelector('.tobii__slide--is-active');
      //groupElement: searches for group membership
      const groupElement = currentSlide.querySelector('[class*="tobii-group-"]');

      // isCustomInlinePopup -> Check if it is our custom lightbox
      const isCustomInlinePopup = groupElement && groupElement.matches('.tobii-group-custom-inline-popup');

      if (isCustomInlinePopup) {
        // If it is our custom lightbox, the generated close button should not be visible
        closeButton.style.display = 'none';
      } else {
        closeButton.style.display = 'block';
        Focus.setFocusToElement(closeButton);
      }

      checkControlVisibility(e.target);
    });

    tobii.on('previous', (e) => {
      checkControlVisibility(e.target);
    });

    tobii.on('next', (e) => {
      checkControlVisibility(e.target);
    });

    // Initialize custom close buttons
    initCloseButtons();
  }

  init() {
    this.initLightbox();
  }
}
